module.exports = __webpack_public_path__ + "img/c1.8b02d26b.png";